import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '平台推荐', path: '/category/pingtai-tuijian' },
    { label: '法律合规', path: '/category/falv-hegui' },
    { label: '安全指南', path: '/category/anquan-zhinan' },
  ],
  内容分类: [
    { label: '行业资讯', path: '/category/hangye-zixun' },
    { label: '观看技巧', path: '/category/guankan-jiqiao' },
    { label: '关于我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-background-50/20 rounded-lg">
                <i className="ri-guide-line text-lg"></i>
              </div>
              <span className="text-lg font-semibold font-heading whitespace-nowrap">
                成人视频指南
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed max-w-sm">
              致力于为成年用户提供日本成人视频相关的合法合规指南、正版平台推荐、安全观看须知等专业内容。帮助您安全、理性地获取成人娱乐资源。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold font-heading mb-4 text-background-50">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/20 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 成人视频指南. 本站内容仅供成年人参考，请遵守当地法律法规。
          </p>
          <p className="text-xs text-background-50/50">
            理性消费 · 合法观看 · 安全第一
          </p>
        </div>
      </div>
    </footer>
  );
}